import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { createClient, JitsuProvider } from "@jitsu/react";

// const jitsuClient = createClient({
//     tracking_host: "https://jitsu-ytdjk-u7702.vm.elestio.app",
//     key: "js.5bw1m1n3m8dwww6midxs84.cd599l46ubt7q7j155haku",
//     randomize_url: true,
//     segment_hook: true
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <JitsuProvider client={jitsuClient}>
        <App />
    // </JitsuProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
